import type { GiftCardConfig } from '#types/config/components/form/giftCard'
import type { RecursivePartial } from '#types/utils'

export default {
  swatches: {
    variant: 'rectangle'
  }
} satisfies RecursivePartial<GiftCardConfig>
